import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classes from '../addScripts.module.scss';
import SelectWithSearch from '../../../../_common/Form/Selects/SelectWithSearch/SelectWithSearch';
import api from '../../../../../api/api';
import utils from '../../../../../utils/utils';
import { ReactComponent as DeleteSvg } from '../../../../../assets/icons/delete.svg';

const infoScript = [
  {
    name: 'Name',
    path: 'name',
    optionWidth: '40%',
  },
  {
    name: 'NDC',
    path: 'NDC',
    optionWidth: '20%',
  },
  {
    name: 'Package Size',
    path: 'packageSize',
    optionWidth: '20%',
  },
  {
    name: 'Quantity',
    path: 'quantity',
    optionWidth: '10%',
  },
  {
    name: 'Cost',
    path: 'cost',
    optionWidth: '10%',
  },
];

let timeout;

const formatCost = (cost) => {
  const numericCost = +String(cost ?? '').replace(/,/g, '');

  return Number.isFinite(numericCost) && numericCost
    ? `$${utils.formattingCurrency(numericCost)}`
    : cost || '-';
};

const MedicationCard = ({
  medicationInfo, currentBrand, setMedication, error,
}) => {
  const [medicationsList, setMedicationsList] = useState([]);
  const [searchValue, setSearchValue] = useState('');
  const [loading, setLoading] = useState(false);

  const searchMedication = (value) => {
    setSearchValue(value);
    clearTimeout(timeout);

    setMedicationsList([]);

    if (value.trim()) {
      setLoading(true);

      timeout = setTimeout(async () => {
        const { data: { data: { response } } } = await api.searchProduct(value);
        const data = response.filter((r) => !medicationInfo.find(({ id }) => id === r.id));

        setMedicationsList(data);
        setLoading(false);
      }, 400);
    } else {
      setLoading(false);
    }
  };

  const selectMedication = (path, option) => {
    setSearchValue('');
    setMedicationsList([]);

    if (option) {
      setMedication(path, option);
    }
  };

  return (
    <div className={classes.medication_wrapper}>
      <h4>Medication</h4>

      <SelectWithSearch
        label="Search"
        wrapperClassName={classes.medication_search}
        searchValue={searchValue}
        onChange={(value) => searchMedication(value)}
        options={medicationsList}
        loading={loading}
        clearValueAfterSelect
        tableOption={infoScript}
        error={error}
        optionKey=""
        onSelectOption={(option) => selectMedication('productsSelected', option)}
      />

      {!!medicationInfo.length && (
        <div className={classes.medication_cards}>
          {medicationInfo.map((m) => (
            <div key={m.id} className={classes.medication_card}>
              <div className={classes.medication_card_header}>
                <p className={classes.medication_card_name}>{m.name}</p>

                <DeleteSvg
                  className={classes.medication_card_close}
                  onClick={() => selectMedication('productsSelected', m)}
                />
              </div>

              <p className={classes.medication_card_subtitle}>
                {`NDC ${m.NDC || '-'}`}

                {!!(m.brand?.replace('-', '') || currentBrand) && (
                  <>
                    {' · '}
                    <span className={classes.medication_card_brand}>
                      {currentBrand || m.brand}
                    </span>
                  </>
                )}
              </p>

              <div className={classes.medication_card_stats}>
                <div className={classes.medication_card_stat}>
                  <p>Package size</p>
                  <p>{m.packageSize || '-'}</p>
                </div>

                <div className={classes.medication_card_stat}>
                  <p>Quantity</p>
                  <p>{m.quantity || '-'}</p>
                </div>

                <div className={classes.medication_card_stat}>
                  <p>Cost</p>
                  <p>{formatCost(m.cost)}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

MedicationCard.propTypes = {
  medicationInfo: PropTypes.array.isRequired,
  currentBrand: PropTypes.string,
  setMedication: PropTypes.func.isRequired,
  error: PropTypes.string,
};

MedicationCard.defaultProps = {
  error: '',
};

export default MedicationCard;
